import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Address } from './Address';
import { Phone } from './Phone';
import { Party as GQLParty } from '@hit/hit-api-client';
import { ExistingPolicies } from './ExistingPolicies';
import { Financials } from './Financials';

@supertypeClass({ toClient: true, toServer: true })
export class Party extends Everything implements GQLParty {
  @property({ comment: 'Mailing address details of the individual', getType: () => Address })
  mailingAddress: Address;

  @property({ getType: () => Address })
  businessAddress: Address;

  @property({ comment: 'Phone details of the Party', getType: () => Phone })
  phone: Phone;

  @property({ comment: 'Alternative Phone details of the Party', getType: () => Phone })
  alternatePhone: Phone;

  @property({ comment: 'E-mail ID of the party' })
  email: string;

  @property({ getType: () => Address })
  legalAddress: Address;

  @property({ getType: () => ExistingPolicies })
  existingPolicies: ExistingPolicies;

  @property({ getType: () => Financials })
  financials: Financials;

  @property({ getType: () => Address })
  verificationAddress: Address;

  @property({ isLocal: true, persist: false })
  partyType: string;

  @property({ isLocal: true, persist: false })
  isAccountHolder: boolean;

  getIsUSCitizenOrEntity(): boolean {
    return false;
  }

  getIsEntityOrTrust(): boolean {
    return false;
  }

  @property({
    values: ['true', 'false'],
    descriptions: { true: 'Yes', false: 'No' },
    comment: 'acknowledgement of the insured / owner that the TIN provided is correct',
  })
  isTINCorrect: boolean;

  constructor() {
    super();
  }

  static new() {
    return new Party().init();
  }

  init() {
    return this;
  }

  get emailName(): string {
    return this.getFullNameOfOwner();
  }

  // overwritten in Person and Entity
  getFullNameOfOwner(): string {
    return '';
  }

  // overwritten in Person and Entity
  emailTrigger() {}
}
